import {Component, Input, signal} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {IconifyComponent} from '../../../../../shared/standalone-components/iconography/iconify/iconify.component';
import {
  LoadingIconComponent
} from '../../../../../shared/standalone-components/loaders/loading-icon/loading-icon.component';
import {TrimValidator} from '../../../../../utils/validators';
import {BorService} from '../../../../../sdk/bor-api';
import {ToastrService} from '../../../../../shared/services/toast/toastr.service';
import {NgClass} from '@angular/common';
import {ReCaptchaV3Service} from 'ng-recaptcha';
import {finalize} from 'rxjs';

@Component({
  selector: 'bor-contacts-section',
  imports: [
    FormsModule,
    IconifyComponent,
    LoadingIconComponent,
    ReactiveFormsModule,
    NgClass
  ],
  templateUrl: './contacts-section.component.html',
  styleUrl: './contacts-section.component.scss',
  host: { class: 'home-sections' }
})
export class ContactsSectionComponent {
  @Input() isPage = false;

  form = new FormGroup({
    fullName: new FormControl('', [Validators.required, TrimValidator]),
    email: new FormControl('', [Validators.required, Validators.email]),
    subject: new FormControl('', [Validators.required, TrimValidator]),
    message: new FormControl('', [Validators.required, TrimValidator]),
  });


  working = signal(false);
  isSuccessful = signal(false);

  constructor(
    private bor:BorService,
    private toastr: ToastrService,
    private recaptchaV3: ReCaptchaV3Service,
  ) {
  }

  hasFormError(formControl: keyof typeof this.form['controls']){
    return (this.form.get(formControl)?.dirty && this.form.get(formControl)?.invalid);
  }

  submitContactForm(){
    if (this.working()) return;

    this.form.markAllAsDirty();
    if (this.form.invalid) {
      return this.toastr.showDanger('Some fields are either missing or invalid');
    }

    this.working.set(true);

    this.recaptchaV3.execute('contactFormAction')
      .subscribe({
        next: (token) => this.doSubmit(token),
        error: (err) => {
          console.error('reCAPTCHA execution failed: ', err);
          this.toastr.showDanger('Captcha Service Unavailable');
          this.working.set(false);
        }
      });
  }

  doSubmit(captchaToken:string) {
    const formValue = this.form.value;
    this.bor.apiV1BorContactMessagesPost({body: {
      ...(formValue as any), captchaToken
    }})
      .pipe(finalize(() => {this.working.set(false)}))
      .subscribe({
        next: res => {
          if (!res.submittedAt){
            this.toastr.showDanger('Failed to submit the form at this time. Please try again later.');
            return;
          }

          this.isSuccessful.set(true);
        },
        error: err => {
          this.toastr.showDanger(err?.error?.message ?? 'Failed to submit the form at this time. Please try again later.');
        }
      });
  }

}
